// Gender unions are indexed as Shopify collection tags: pagination and native
// Brand/Price filters are evaluated by Shopify against the complete collection.
class FPGenderFilter extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.syncSelection();
    this.addEventListener('change', event => event.stopPropagation());
    this.addEventListener('click', event => {
      if (event.target.closest('[data-gender-apply]')) {
        event.preventDefault(); event.stopPropagation(); this.navigate(false);
      } else if (event.target.closest('[data-gender-clear]')) {
        event.preventDefault(); event.stopPropagation(); this.navigate(true);
      }
    });
    // Clear links remain useful with JavaScript disabled.
    const clear = this.querySelector('[data-gender-clear]');
    if (clear) clear.href = this.destination([]).href;
  }
  syncSelection() {
    const genderTag = location.pathname.split('/').flatMap(part => part.split('+'))
      .map(part => decodeURIComponent(part)).find(part => part.startsWith('fp-gender-'));
    const selected = genderTag ? genderTag.slice('fp-gender-'.length).split('-') : [];
    this.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.checked = selected.includes(input.value);
    });
  }
  destination(selected) {
    const url = new URL(location.href);
    const base = this.dataset.base.replace(/\/$/, '');
    const tags = url.pathname.slice(base.length).split('/').filter(Boolean).flatMap(s => s.split('+'))
      .filter(t => !decodeURIComponent(t).startsWith('fp-gender-'));
    if (selected.length && selected.length < 3) tags.push('fp-gender-' + selected.join('-'));
    url.pathname = base + (tags.length ? '/' + tags.join('+') : '');
    url.searchParams.delete('page'); url.hash = '';
    return url;
  }
  navigate(clear) {
    const selected = clear ? [] : [...this.querySelectorAll('input:checked')].map(input => input.value);
    location.assign(this.destination(selected));
  }
}
if (!customElements.get('fp-gender-filter')) customElements.define('fp-gender-filter', FPGenderFilter);

// A native Clear all may remove a gender path. Navigate fully so the drawer,
// active summary, canonical URL and history all agree with the new page.
document.addEventListener('click', event => {
  const remove = event.target.closest('facet-remove-component[data-url]');
  if (!remove || !location.pathname.includes('/fp-gender-')) return;
  const target = new URL(remove.dataset.url, location.href);
  if (target.pathname !== location.pathname) {
    event.preventDefault(); event.stopImmediatePropagation(); location.assign(target);
  }
}, true);

// Back/forward cache can restore unapplied checkbox edits from the old page.
// Reconcile them with the URL that actually determines server-side membership.
window.addEventListener('pageshow', () => {
  document.querySelectorAll('fp-gender-filter').forEach(filter => filter.syncSelection());
});

// Treat desktop filter popovers as one group. Opening a drawer closes them too.
document.addEventListener('click', event => {
  const summary = event.target.closest('.fp-filter-bar summary');
  const drawerTrigger = event.target.closest('[on\\:click="#filters-drawer/open"]');
  if (summary || drawerTrigger) {
    const keep = summary?.closest('details');
    document.querySelectorAll('.fp-filter-bar details[open]').forEach(details => {
      if (details !== keep) details.open = false;
    });
  } else if (!event.target.closest('.fp-filter-bar')) {
    document.querySelectorAll('.fp-filter-bar details[open]').forEach(details => { details.open = false; });
  }
}, true);
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('.fp-filter-bar details[open]');
  if (details) { details.open = false; details.querySelector('summary')?.focus(); }
});
